import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SsoPage } from '@/features/auth/components/SsoPage';

export const Route = createFileRoute('/sso')({
  component: () => (
    <ErrorBoundary moduleName="SSO">
      <Suspense fallback={<PageLoader />}>
        <SsoPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
